import { useMemo } from 'react';

import {
   AlignItems,
   createDynamicColumnsWidth,
   InteractiveTable,
   InteractiveTableColumnConfiguration,
   JustifyContent,
} from '@dreryk/react-components';

import { PractitionerSafePresenter } from '~libs.desktop.shared.practitioner-safe-presenter';

import { EmergencyNotificationInAppConfigurationResponseTeamPractitionerValue } from '../EmergencyNotificationInAppConfigurationResponseTeamPractitionersField.types';
import { translationKeys } from '../../../../translations';

export const useEmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTableColumnConfigurationOptions = (): InteractiveTableColumnConfiguration<EmergencyNotificationInAppConfigurationResponseTeamPractitionerValue>[] => {
   return useMemo((): InteractiveTableColumnConfiguration<EmergencyNotificationInAppConfigurationResponseTeamPractitionerValue>[] => {
      const columnWidths = createDynamicColumnsWidth({
         controller: '0px',
         name: '100%',
         options: '24px',
      });

      return [
         {
            name: 'controller',
            width: columnWidths.controller,
            hidden: true,
            renderer: ({ bean, index }) => (
               <InteractiveTable.ControllerCell
                  name={'practitioner'}
                  testId={'practitioner'}
                  index={index}
                  defaultValue={bean.practitioner}
               />
            ),
         },
         {
            name: 'practitioner',
            label: translationKeys.user,
            width: columnWidths.name,
            justifyContent: JustifyContent.START,
            alignItems: AlignItems.CENTER,
            renderer: ({ bean: { practitioner } }) => {
               return (
                  <InteractiveTable.Cell testId={'practitioner'}>
                     <PractitionerSafePresenter
                        testId={'author'}
                        practitioner={practitioner}
                        type={'standalone'}
                        withIdentification
                     />
                  </InteractiveTable.Cell>
               );
            },
         },

         {
            name: 'options',
            width: columnWidths.options,
            renderer: ({ index }) => {
               return <InteractiveTable.DeleteRowCell index={index} />;
            },
         },
      ];
   }, []);
};
